require ('jquery');
import {gsap} from 'gsap';
$(document).ready(function () {
    $('.burger').click(function(){
        let windowWidth = $(window).width();
        let width = '';
        if(windowWidth<592){
            width = "100%";
        } else {
            width = "50%";
        }

        if($(this).hasClass('open')){
            $(this).removeClass('open');
            $('body').removeClass('fixed');

            let tl = gsap.timeline();

            tl
                .to('nav.nav .item-nav',0.2,{autoAlpha:0})
                .to('nav.nav',0.3,{width:"0"});

        }else{
            $(this).addClass('open');
            $('body').addClass('fixed');

            let tl = gsap.timeline();

            tl
                .to('nav.nav',0.5,{width:width})
                .to('nav.nav .item-nav',0.3,{autoAlpha:1});

        }
    })

    $(document).on('click','body.fixed .nav .item-nav > a',function (e) {
        if($(this).parents('.item-nav').find('.submenu-nav').length>0){
            e.preventDefault();
            $('.nav .item-nav').removeClass('active');
            gsap.to('.nav .submenu-nav',0.3,{autoAlpha:0});
            $(this).parents('.item-nav').addClass('active');
            gsap.to($(this).parents('.item-nav').find('.submenu-nav'),0.3,{autoAlpha:1});
        }
    })

})



// WEBPACK FOOTER //
// ./resources/js/menu.js